import { ReactNode, createContext, useEffect, useState } from "react";

export interface ProjectFilesContextValue {
  selectedItems: Array<string> | string;
  setSelectedItems: React.Dispatch<React.SetStateAction<Array<string> | string>>;
  selectedFileIds: string[];
  setSelectedFileIds: React.Dispatch<React.SetStateAction<string[]>>;
}

export const ProjectFilesContext = createContext<ProjectFilesContextValue>(
  {} as ProjectFilesContextValue
);

export default function ProjectFilesContextProvider({
  children,
  initialSelectedItems = null,
}: {
  children: ReactNode;
  initialSelectedItems?: string | Array<string> | null;
}) {
  const [selectedItems, setSelectedItems] = useState<string | Array<string> | null>(
    initialSelectedItems
  );
  const [selectedFileIds, setSelectedFileIds] = useState<string[]>([]);

  useEffect(() => {
    setSelectedItems(initialSelectedItems);
    setSelectedFileIds([]);
  }, [initialSelectedItems]);

  return (
    <ProjectFilesContext.Provider
      value={{
        selectedItems,
        setSelectedItems,
        selectedFileIds,
        setSelectedFileIds,
      }}
    >
      {children}
    </ProjectFilesContext.Provider>
  );
}
